import { FC } from "react";
import cn from "classnames";
import { ISelectOption } from "src/@types/form";
import { ButtonSelectorItem } from "./ButtonSelectorItem";
import { ISingleButtonSelector } from "./types";

export const SingleButtonSelector: FC<ISingleButtonSelector> = ({
  className,
  selectorClassName,
  options,
  activeOption,
  setActiveOption,
}) => {
  const updateActiveOption = (newOption: ISelectOption) => {
    setActiveOption(newOption);
  };

  return (
    <div className={cn("flex gap-4", className)}>
      {options.map((option) => (
        <ButtonSelectorItem
          key={option.id}
          className={selectorClassName}
          option={option}
          isSelected={activeOption === option.value}
          onClick={updateActiveOption}
        />
      ))}
    </div>
  );
};
